import {
  ColumnOptionsBase,
  EntityColumn,
  entityColumn,
  GridRef,
  GroupColumnRef,
  ServerSideColumnOption,
  stringColumn
} from '@softapps/core';
import { Stock } from './stock';
import { Signal } from '@angular/core';
import { Translation } from '@softline/ui-core';
import { StockColumnComponent } from './stock-column.component';

export interface ClientSideStockColumnOptions<TRow extends object> extends ColumnOptionsBase<TRow, Stock> {
  rowGroup?: boolean;
}

export interface ServerSideStockColumnOptions<TRow extends object> extends ColumnOptionsBase<TRow, Stock>, ServerSideColumnOption {
  rowGroup?: boolean;
}

export type StockColumnOptions<TRow extends object> = ClientSideStockColumnOptions<TRow> | ServerSideStockColumnOptions<TRow>;

export function stockColumn<TRow extends object>(ref: GridRef<TRow> | GroupColumnRef<TRow>,
                                                 translator: (key: string) => Signal<Translation>,
                                                 options: StockColumnOptions<TRow>): EntityColumn<TRow, Stock>{
  return entityColumn(ref, {
    ...options,
    format: v => `${v.lager} - ${v.name1}`,
    sortBy: v => v.lager,
    cellRenderer: StockColumnComponent,
    serverSideSortField: 'lager',
  }, entityRef => {
    stringColumn(entityRef, {
      colId: 'stock',
      header: translator('Lager'),
      getValue: v => v.lager
    });
    stringColumn(entityRef, {
      colId: 'name',
      header: translator('Name'),
      getValue: v => v.name1
    });
  });
}
